/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {InviteLinkModel} from "../../models/invite-link-model";
import {PaginatedList} from "../../models/paginator/paginated-list";

export interface InviteLinksGetParams {
    questionnaireGuid?: string;
    pageNumber?: number;
    pageSize?: number;
}

export function inviteLinksGet(http: HttpClient, rootUrl: string, params: InviteLinksGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<InviteLinkModel>>> {
    const rb = new RequestBuilder(rootUrl, inviteLinksGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params.questionnaireGuid) {
        rb.query('questionnaireGuid', params.questionnaireGuid)
    }
    if (params.pageNumber) {
        rb.query('pageNumber', params.pageNumber)
    }
    if (params.pageSize) {
        rb.query('pageSize', params.pageSize)
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<PaginatedList<InviteLinkModel>>;
        })
    );
}

inviteLinksGet.PATH = '/api/v1/invite-links';
